import Head from 'next/head';
import { FaucetContainer } from '@/components/FaucetContainer/FaucetContainer';

export default function ClaimETHPage() {
  return (
    <>
      <Head>
        <title>Claim ETH &mdash; Garnet</title>
      </Head>
      <FaucetContainer />
    </>
  );
}
